'use client';

import clsx from 'clsx';
import type { ReactNode } from 'react';

import styles from './RepairDetailsShell.module.scss';

interface RepairDetailsShellProps {
  sidebar?: ReactNode;
  sidebarPlacement?: 'start' | 'end';
  children: ReactNode;
}

export function RepairDetailsShell({
  sidebar,
  sidebarPlacement = 'start',
  children,
}: Readonly<RepairDetailsShellProps>) {
  const aside = sidebar ? (
    <aside className={clsx(styles.sidebar, sidebarPlacement === 'end' && styles.sidebarEnd)}>
      {sidebar}
    </aside>
  ) : null;
  const main = <div className={styles.mainColumn}>{children}</div>;

  return (
    <div className={styles.shell}>
      <div
        className={clsx(
          'container',
          styles.layout,
          !sidebar && styles.layoutNoSidebar,
          sidebar && sidebarPlacement === 'end' && styles.layoutSidebarEnd
        )}
      >
        {sidebarPlacement === 'end' ? (
          <>
            {main}
            {aside}
          </>
        ) : (
          <>
            {aside}
            {main}
          </>
        )}
      </div>
    </div>
  );
}
